import Account                                          from "../../../domain/account/Account";
import { AccountAction, ACTION_TYPE, SetAccountAction } from "./AccountAction";

const accountReducer = (state: Account = new Account(), action: AccountAction): Account => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_ACCOUNT:
      const setAccountAction: SetAccountAction = action as SetAccountAction;
      return setAccountAction.account;
  }
};

export default accountReducer;
